import { gql } from "@apollo/client";

export const UpdateInstalledBaseRegionSubscription = gql`
    mutation UpdateInstalledBaseRegionSubscription ($id: ID!, $input: InstalledBaseRegionSubscriptionInput!) {
        updateInstalledBaseRegionSubscription(id: $id, input: $input) {
            id
            inApp
            mail
            push
            iotAlert
            iotAlertSeverity
            maintenanceDue
            maintenanceSeverity
            maintenanceType
            insert
            update
            region {
                id
                name
            }
        }
    }
`;
